import React from 'react';
import ReactDOM from 'react-dom';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { ThemeProvider } from 'styled-components';
import Modal from 'react-modal';
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { msalConfig } from './config/authConfig';
import App from './App';
import theme from './config/theme';
import './index.css';
import './map.css';

export const msalInstance = new PublicClientApplication(msalConfig);

library.add(fal, fas);
dom.watch();

Modal.setAppElement('#root');

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

